import React, { Component } from 'react';
import { Image, Platform, StatusBar, View, StyleSheet } from 'react-native';
import { SafeAreaInsetsContext } from 'react-native-safe-area-context';

import Colors from '../constants/Colors';

const logo = require('../assets/images/plentiful_logo_and_label.png');
class EmptyScreen extends Component {
  render() {
    return (
      <SafeAreaInsetsContext.Consumer>
        {(insets) => (
          <View
            style={[
              styles.view,
              {
                paddingTop: insets.top,
              },
            ]}
          >
            {Platform.OS === 'ios' && <StatusBar barStyle="light-content" />}
            <Image source={logo} resizeMode="cover" style={styles.icon} />
          </View>
        )}
      </SafeAreaInsetsContext.Consumer>
    );
  }
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.mediumBlue,
  },
  icon: {
    resizeMode: 'contain',
  },
});

export default EmptyScreen;
